import React, { Component } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import axios from 'axios'
import '../css/UsageStats.css';

class UsageStats extends Component {
    constructor(props) {
        super(props)
        this.state = {
            StatData: {
                Characters: 0,
                Items: 0
            },
            loaded: false
        }
    }


    // attempt to pull stats from API
    _getStats = async () => {
        var apiEndpoint = process.env.REACT_APP_TROVE_SERVICE;

        const url = apiEndpoint + '/Trove/stats';
        // use axios to fetch the character from the api:
        axios.get(url)
            .then(res => {
                if (res.data !== undefined) {
                    let totalCharacterUploads = res.data.characters;
                    let totalItemUploads = res.data.items;

                    this.setState(({
                        StatData: { Characters: totalCharacterUploads, Items: totalItemUploads },
                        loaded: true
                    }),
                        () => {
                            console.log(this.state.StatData)
                        }
                    );
                }
            }).catch(e => {
                this.setState((state) => ({
                    errorMessage: state.errorMessage + " " + e.message
                }),
                    () => console.log(`Error message: ` + this.state.errorMessage));
            });
    }

    /* init */
    componentDidMount() {
        this._getStats();
    }

    render() {
        const { loaded, StatData } = this.state;

        if (loaded) {
            return (
                <Container className="stats">
                    {StatData.Characters > 0 ? (
                        <Row>
                            <Col>
                                Total characters uploaded: {StatData.Characters.toLocaleString()}
                            </Col>
                        </Row>
                    ) : null}
                    {StatData.Items > 0 ? (
                        <Row>
                            <Col>
                                Total items uploaded: {StatData.Items.toLocaleString()}
                            </Col>
                        </Row>
                    ) : null}
                </Container>
            );
        } else {
            return null
        }
    }
}

export default UsageStats;